import React, { useState, useEffect } from "react";
import { Button, Row, Col, Modal } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import moment from "moment";
import "./Programe.css";
import ModalProgram from "../Programe/ModalProgram";
import ServiceProgram from "./ServicePrograme/ServicePrograme";
import Navbar from "../../Member/Navbar/Navbar";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import FileCopyIcon from "@material-ui/icons/FileCopy";

const Programe = (props) => {
  useEffect(() => {
    GetDataProgram();
  }, []);

  const user = {
    id: JSON.parse(sessionStorage.getItem("user")).id,
  };

  const GetDataProgram = () => {
    ServiceProgram.getdataprograme(user.id).then((res) => {
      setInfo(res.data);
    });
  };

  const DeleteProgram = (id) => {
    ServiceProgram.deleteprograme(id).then((res) => {
      setInfo(INFO.filter((x) => x.id !== id));
      setShow(false);
    });
  };
  const Dupliquer = (id) => {
    ServiceProgram.dupliquer(id).then((res) => {
      setInfo(INFO.filter((x) => x.id !== id));
      window.location.reload();
    });
  };
  //popup annuler
  const [idDelete, setIdDelete] = useState("");
  const [show, setShow] = useState(false);
  const Toggle = () => {
    setShow(false);
  };

  // modal update
  const [showProg, setShowProg] = useState(false);
  const [progId, setProgId] = useState();
  const HandleShow = (id) => {
    setProgId(id);
    setShowProg(true);
  };
  const ToggleProg = () => {
    setShowProg(false);
  };

  const { SearchBar } = Search;

  const [INFO, setInfo] = useState([]);
  const [listhours, setListhours] = useState([]);
  //console.log("list", listhours);

  // console.log("hours1", matin);
  // console.log("hours2", apresmidi);
  // console.log("hours3", nuitee);

  //pagination :
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      &thinsp; De {from} à {to} sur {size}
    </span>
  );

  const options = {
    paginationSize: 4,
    pageStartIndex: 0,
    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: "<<",
    prePageText: "<",
    nextPageText: ">",
    lastPageText: ">>",
    nextPageTitle: "Premier page",
    prePageTitle: "Pre page",
    firstPageTitle: "Suivant Page",
    lastPageTitle: "Fin page",
    showTotal: true,

    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "5",
        value: 5,
      },
      {
        text: "10",
        value: 10,
      },
      {
        text: "Plus",
        value: INFO.length,
      },
    ], // A numeric array is also available. the purpose of above example is custom the text
  };

  const columns = [
    {
      dataField: "designation",
      text: "Designation",
      headerAlign: "center",
      align: "center",
      sort: true,
    },
    {
      dataField: "capacity",
      text: "Capacité",
      headerAlign: "center",
      align: "center",
      sort: true,
    },
    {
      dataField: "date",
      text: "Date",
      headerAlign: "center",
      align: "center",
      sort: true,
    },
    // {
    //   dataField: "type",
    //   text: "Prestation",
    //   headerAlign: "center",
    //   align: "center",
    //   sort: true,
    // },
    {
      dataField: "matin",
      text: "Matin",
      headerAlign: "center",
      align: "center",
      sort: true,
    },
    {
      dataField: "apresmidi",
      text: "Aprés Midi",
      headerAlign: "center",
      align: "center",
      sort: true,
    },
    {
      dataField: "nuitee",
      text: "Soir",
      headerAlign: "center",
      align: "center",
      sort: true,
    },
    {
      dataField: "action",
      text: "Actions",
      headerAlign: "center",
      align: "center",
      sort: true,
    },
  ];

  const defaultSorted = [
    {
      dataField: "designation",
      dataField: "id",
      dataField: "price",
      order: "desc",
    },
  ];

  const infouser = [];
  INFO.map((info, i) => {
    infouser.push({
      designation: info.designation,
      capacity: info.capacity,
      date: moment(info.datePlaning).format("DD/MM/YYYY"),
      // type: info.typePlan,
      // matin: "",
      matin: Object.values(INFO[i])
        .slice(4)
        .filter((item) =>
          moment(item, "HHmm").isBetween(
            moment("06:00", "HHmm"),
            moment("13:00", "HHmm"),
            undefined,
            "[]"
          )
        )

        .map((number) => <li>{number}</li>),
      apresmidi: Object.values(INFO[i])
        .slice(4)
        .filter((item) =>
          moment(item, "HHmm").isBetween(
            moment("13:30", "HHmm"),
            moment("18:30", "HHmm"),
            undefined,
            "[]"
          )
        )

        .map((number) => <li>{number}</li>),
      nuitee: Object.values(INFO[i])
        .slice(4)
        .filter(
          (item) =>
            moment(item, "HH:mm").isAfter(moment("18:30", "HH:mm")) ||
            moment(item, "HH:mm").isBefore(moment("06:00", "HH:mm"))
        )

        .map((number) => <li>{number}</li>),
      action: (
        <div>
          <Button
            variant="info"
            className="dup mr-2"
            onClick={() => {
              Dupliquer(info.id);
            }}
          >
            <FileCopyIcon />
          </Button>
          <Button
            variant="success"
            className="upd mr-2"
            onClick={() => {
              HandleShow(info.id);
            }}
          >
            <EditIcon />
          </Button>
          <Button
            className="del mr-2"
            variant="danger"
            onClick={() => {
              setIdDelete(info.id);
              setShow(true);
            }}
          >
            <DeleteIcon />
          </Button>
        </div>
      ),
    });
  });

  // Implement startWith instead of contain
  function customMatchFunc({ searchText, value, column, row }) {
    if (typeof value !== "undefined") {
      return value.startsWith(searchText);
    }
    return false;
  }
  return (
    <>
      <Navbar />
      <div className="container program">
        <ModalProgram
          showProg={showProg}
          toggleProg={ToggleProg}
          idProg={progId}
          infos={INFO}
        />

        <Modal show={show} onHide={Toggle}>
          <Modal.Body>
            <img
              src="https://img.icons8.com/fluent/48/000000/close-window.png"
              style={{ float: "right" }}
              alt="close"
              onClick={Toggle}
            />
            <h6
              style={{
                marginTop: "27px",
                marginBottom: "18px",
                textAlign: "center",
              }}
            >
              Êtes-vous sûr d'annuler ce programme ?
            </h6>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="info" onClick={() => DeleteProgram(idDelete)}>
              Oui
            </Button>

            <Button className="mr-auto" variant="danger" onClick={Toggle}>
              Non
            </Button>
          </Modal.Footer>
        </Modal>
        <h3
          style={{
            borderRadius: "0.25em",
            textAlign: "center",
            border: "1px solid purple",
            padding: "0.5em",
            marginTop: "10px",
          }}
        >
          Mes Planifications
        </h3>

        <ToolkitProvider
          keyField="id"
          data={infouser}
          columns={columns}
          search={{ customMatchFunc }}
        >
          {(props) => (
            <div>
              <SearchBar {...props.searchProps} />

              <BootstrapTable
                striped
                {...props.baseProps}
                defaultSorted={defaultSorted}
                pagination={paginationFactory(options)}
              />
            </div>
          )}
        </ToolkitProvider>
      </div>
    </>
  );
};

export default Programe;
